import { Controller } from '@hotwired/stimulus'
import { loadTurboFrame } from 'helpers/turbo_frames'

// Drives the moment-survey form: Q1 reveals the activity picker (plus the
// narrative for a Yes), and the picker frame loads the code roots matching
// the chosen answer (Yes -> working, No -> not_working).
export default class extends Controller {
  static targets = ['sections', 'frame', 'codeError', 'description', 'descriptionSection', 'descriptionError']
  static values = { workingUrl: String, notWorkingUrl: String }

  connect() {
    // On a 422 re-render the server already rendered the right picker; seeding
    // currentType from the checked radio prevents a src-set from wiping it.
    const checked = this.element.querySelector('input[name="time_study_response[working_status]"]:checked')
    this.currentType = checked ? checked.dataset.timeStudySurveyFormActivityTypeParam : null
  }

  select(event) {
    this.sectionsTarget.classList.remove('d-none')

    const type = event.params.activityType
    if (type === this.currentType) return

    this.currentType = type
    this.toggleDescriptionSection()
    // This frame reload is a working-status switch, not the user drilling the
    // picker. Its turbo:frame-load must not wipe a code error that previewSubmit
    // may show in the same tick — on slow loads the events race (see spec).
    this.switchingType = true
    loadTurboFrame(this.frameTarget, type === 'working' ? this.workingUrlValue : this.notWorkingUrlValue)
  }

  // We don't ask what a participant was up to while off the clock (GRC-528).
  toggleDescriptionSection() {
    const hidden = this.currentType === 'not_working'
    this.descriptionSectionTarget.classList.toggle('d-none', hidden)
    if (hidden) this.clearDescriptionError()
  }

  clearCodeError() {
    if (this.switchingType) {
      this.switchingType = false
      return
    }
    if (this.hasCodeErrorTarget) this.codeErrorTarget.classList.add('d-none')
  }

  clearDescriptionError() {
    if (this.hasDescriptionErrorTarget) this.descriptionErrorTarget.classList.add('d-none')
  }

  // Preview mode: the form never posts, so mimic the server-side validations
  // and show the same inline errors before revealing the thanks banner.
  previewSubmit() {
    if (!this.element.querySelector('input[name="time_study_response[working_status]"]:checked')) {
      // Q2/Q3 are still hidden at this point, so theirs are the only errors worth raising later.
      this.element.querySelector('.ts-option-cards').classList.add('ts-option-cards--error')
      document.getElementById('ts-q1-error').classList.remove('d-none')
      return
    }

    let valid = true

    if (!document.getElementById('activity_code_id_field')?.value) {
      this.codeErrorTarget.classList.remove('d-none')
      valid = false
    }

    if (this.currentType !== 'not_working' && !this.descriptionTarget.value.trim()) {
      this.descriptionErrorTarget.classList.remove('d-none')
      valid = false
    }

    if (!valid) return

    document.getElementById('response_form').classList.add('d-none')
    document.getElementById('time_study_preview_thanks').classList.remove('d-none')
  }
}
